import WhyBlocks from "./WhyBlocks";

export default function ThankYou() {
    return (
        <div className="App thank-you">
            <div className="questionnaire full-page">
                <div className="questionnaire__question">
                    <div className="call-me-page">
                        <div className="call-me-page__block one-block">
                            <div className="call-me-page__block-content">
                                <h2>Спасибо что ответили на все вопросы!</h2>
                                <div className="call-me-text call-me-text--recall">В течении 15 минут наш менеджер Вам перезвонит.</div>

                                <div className="badge-container">
                                    <div className="badge full">
                                        <div className="left">Ваша скидка</div>
                                        <div className="right">-20%</div>
                                    </div>
                                </div>
                                
                                
                                <div className="call-me-text call-me-text--why">Почему нам доверяют?</div>
                                <WhyBlocks />
                                
                            </div>
                        </div>
                    </div>
                    <div className="side-footer">
                        <a href="tel:+79854327045" target="_parent" className="">+7 985 432-70-45</a>
                    </div>
                </div>
            </div>
        </div>
    )
}